import BaseModel from '../core/BaseModel'
export default class GroupPermissionModel extends BaseModel {
    constructor() {
        super({ 
                name: "group_permission",
                tableName: 'core_group_permission',
                display_key: 'name'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}